export const IMAGES_TAGS = Object.freeze({
  photo_front: 'photo_front',
  photo_back: 'photo_back',
});
